exports.components = {
  "component---src-pages-cat-dental-chart-js": () => import("./../../../src/pages/cat-dental-chart.js" /* webpackChunkName: "component---src-pages-cat-dental-chart-js" */),
  "component---src-pages-dog-dental-chart-js": () => import("./../../../src/pages/dog-dental-chart.js" /* webpackChunkName: "component---src-pages-dog-dental-chart-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

